import type { SeriesTemplateScheduleType, SeriesTemplateType } from './types'

export const SERIES_TEMPLATE_TYPE_STANDARD = 'standard'
export const SERIES_TEMPLATE_TYPE_ROLLING = 'rolling'

export const SERIES_TEMPLATE_TYPES = [
  SERIES_TEMPLATE_TYPE_STANDARD,
  SERIES_TEMPLATE_TYPE_ROLLING,
] as const

export const SERIES_TEMPLATE_TYPE_TO_LABEL: Record<SeriesTemplateType, string> = {
  standard: 'Standard',
  rolling: 'Rolling',
}

export const ROLLING_SCHEDULER_WEEKS_TO_SHOW = 5

export const RECURRING_SERIES_TEMPLATE_SCHEDULE_TYPES = [
  'weekly',
  'biweekly',
  'everyTwoWeeks',
] as const

export const SERIES_TEMPLATE_SCHEDULE_TYPES = [
  'flexible',
  ...RECURRING_SERIES_TEMPLATE_SCHEDULE_TYPES,
] as const

export const SERIES_TEMPLATE_SCHEDULE_TYPE_TO_LABEL: Record<SeriesTemplateScheduleType, string> = {
  flexible: 'Flexible',
  weekly: 'Weekly',
  biweekly: 'Twice a week',
  everyTwoWeeks: 'Every two weeks',
}
